import FooterGlobal from "./footer-global";
// import FooterBar from "./footer-bar";

const modul = angular
    .module("footerComponents", [])

    .directive("footerGlobal", FooterGlobal);
//.directive("footerBar", FooterBar);

export default modul.name;
